var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentcolor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 31.4c-.8 0-1.4-.3-2-.8-.5-.6-.8-1.2-.8-2V10.8c0-.8.3-1.4.8-2 .6-.5 1.2-.8 2-.8h23.4c.8 0 1.4.3 2 .8.5.6.8 1.2.8 2v17.8c0 .8-.3 1.4-.8 2-.6.5-1.2.8-2 .8H7.8ZM19.5 21 7.8 13.2v15.4h23.4V13.2L19.5 21Zm0-2.6L31 10.8H7.9l11.6 7.6ZM7.8 13.2v-2.4 17.8-15.4Z"
  })));
};
export default SvgEmail;